import { faThumbTack } from "@fortawesome/pro-regular-svg-icons";

import { Pill } from "src/base-components/Pill";

export const RelatedBlockTabLabel: React.FC<{
  children: React.ReactNode;
  pinnedCount: number;
}> = ({ children, pinnedCount }) => {
  return (
    <div className="flex items-center gap-x-1.5">
      {children}
      {pinnedCount > 0 && (
        <Pill size="sm">
          <Pill.Icon icon={faThumbTack} />
          <Pill.Text>{pinnedCount}</Pill.Text>
        </Pill>
      )}
    </div>
  );
};
